import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import { 
  Field, 
  getFormValues, 
  SubmissionError 
} from 'redux-form'
import { 
  Button, 
  Confirm, 
} from  'semantic-ui-react'

import { 
  StdCard ,
  CommentRow
} from 'components'
import { 
  actionPOUpdate,
  postPreReject,
  postPrePurchaseSubmit,
  postPurchaseSubmit,
  closeAcceptConfirm,
  closeRejecttConfirm,
  closePurchaseSubmitConfirm
} from 'ducks/poUpdate'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { Cont } from './styled'

const Approve = (props) => {
  const { 
    actionPOUpdate, 
    postPreReject,
    postPrePurchaseSubmit,
    postPurchaseSubmit,
    valueForm,
    //props
    history ,
    data={}, 
    handleSubmit, 
  } = props
  const approverAction = data.actions||['Approve', 'Revise', 'Reject']

  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  function submitValidate(action){
    setSubmitActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if(['reject','revise','cancel'].indexOf(action.toLowerCase())>=0) {
        if((valueForm.actionComment&&valueForm.actionComment.trim().length === 0)||!valueForm.actionComment) {
          throw new SubmissionError({ actionComment: 'Required!'})
        }
      }
      setShowConfirm(true)
    })
  }

  function submitAction(confirmSubmit=false) {
    setShowConfirm(false)
    if(submitActionName.toLowerCase()=='accept'){
      props.closeAcceptConfirm()
      postPrePurchaseSubmit({
        docId: valueForm.id,
        sn: valueForm.sn,
        action: submitActionName,
        comment: valueForm.actionComment,
        commentAttachments: valueForm.commentAttachments
      },confirmSubmit,history)
    }else if(submitActionName.toLowerCase()=='reject'){
      props.closeRejecttConfirm()
      postPreReject({
        docId: valueForm.id,
        sn: valueForm.sn,
        action: submitActionName,
        comment: valueForm.actionComment,
        commentAttachments: valueForm.commentAttachments
      },confirmSubmit,history)
    }else{
      actionPOUpdate({
        docId: valueForm.id,
        sn: valueForm.sn,
        action: submitActionName,
        comment: valueForm.actionComment,
        commentAttachments: valueForm.commentAttachments
      }, history)
    }
  }

  const purchaseActionConfirm = () =>{
    props.closePurchaseSubmitConfirm()
    postPurchaseSubmit({
      docId: valueForm.id,
      sn: valueForm.sn,
      action: submitActionName,
      comment: valueForm.actionComment,
      commentAttachments: valueForm.commentAttachments,
      confirmedDP: true
    }, history)
  }


  return (
    approverAction.length === 0 ? null :
    <React.Fragment>
      <StdCard title={`Action ${valueForm&&valueForm.status==5?'':'for Approval'}`} highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <Cont>
          <div style={{ display:'flex', flexDirection: 'column' }}>
            <Field 
              name='actionComment' 
              label='Your Comment' 
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} /> 
            <Field
              name='commentAttachments'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{ marginTop: '1rem' }}>
              {
                approverAction.map((item) => 
                  <Button 
                    key={item}
                    type='button' 
                    color={`${['reject','cancel'].indexOf(item.toLowerCase())>=0?'red':item.toLowerCase()==='revise'?'orange':'green'}`}
                    onClick={
                      handleSubmit(()=>submitValidate(item))
                    }
                  >
                    {pascalCase(item)}
                  </Button>
                )
              }
            </div>
          </div>
          <Confirm
            size='tiny'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />  
          <Confirm
            size='tiny'
            open={props.acceptConfirm.show}
            content={props.acceptConfirm.message}
            onCancel={() => props.closeAcceptConfirm()}
            onConfirm={() => submitAction(true)}
          />  
          <Confirm
            size='tiny'
            open={props.rejectConfirm.show}
            content={props.rejectConfirm.message}
            onCancel={() => props.closeRejecttConfirm()}
            onConfirm={() => submitAction(true)}
          />  
          <Confirm
            size='tiny'
            open={props.purchaseSubmitConfirm.show}
            content={props.purchaseSubmitConfirm.message}
            onCancel={() => props.closePurchaseSubmitConfirm()}
            onConfirm={() =>purchaseActionConfirm()}
          />  
        </Cont>
      </StdCard>
      <div style={{height:'1rem'}}/>
      <StdCard title='Last Comment' style={{ marginTop: '1rem' }} enableCollapse>
        <Cont>
          {valueForm&&valueForm.comments&&valueForm.comments[0]&&
            <CommentRow 
            data={valueForm&&valueForm.comments&&valueForm.comments[0]} 
            files={valueForm&&valueForm.attachments.filter(x=>x.commentId===valueForm.comments[0].id)} />}
        </Cont>
      </StdCard>
    </React.Fragment>
  )

}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formPOUpdate')(state)||{},
    acceptConfirm: state.poUpdate.acceptConfirm,
    rejectConfirm: state.poUpdate.rejectConfirm,
    purchaseSubmitConfirm: state.poUpdate.purchaseSubmitConfirm,
  })
}

const mapDispatchToProps = {
  actionPOUpdate,
  postPreReject,
  postPrePurchaseSubmit,
  postPurchaseSubmit,
  closeAcceptConfirm,
  closeRejecttConfirm,
  closePurchaseSubmitConfirm
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
